module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/zmcoZH/tc-custom/9781667445434.jpg?1680370567019",
      "alt": "This image is the cover for the book Houx et Amour, Le scandale rencontre l'amour"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Houx et Amour, Le scandale rencontre l'amour\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("La magie du houx réunira-t-elle Joséphine et Ace pour un Noël inoubliable ? "), _c('br'), _vm._v(" Lorsque Joséphine et Ace sont envoyés en mission pour trouver toutes les décorations nécessaires en vue d’un bal de Noël au Fortuna, ils trouvent plus que ce qu'ils avaient prévu. Mais une couturière et un videur de salle de jeu peuvent-ils trouver l'amour ensemble ?"), _c('br'), _vm._v(" Laissez-vous tenter par ce court récit de Noël, dès aujourd’hui."), _c('br')]), _vm._v(" "), _c('p')]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Amanda Mariel, Elodie Demogue\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Amanda Mariel, auteure de best-seller USA Today, rêve des jours passés où la vie se déroulait à un rythme plus lent. Elle aime prendre un stylo et du papier et explorer les périodes historiques à travers son imagination et ses écrits. Lorsqu'elle n'écrit pas, elle lit, fait du crochet, voyage, exerce ses talents de photographe ou bien passe du temps avec sa famille."), _c('br')])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Babelcube Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0